<template>
	<section>
		<b-loading :active.sync="isLoading"></b-loading>
		<b-button
			@click='params.archived = !params.archived'>
			{{ params.archived ? 'Show Active' : 'Show Archived' }}
		</b-button>
		<b-button
			@click="bulkArchiveRestore('archive')"
			type="is-warning" v-if="!params.archived"
			:disabled="!archiveCheckedList.length"
			>
			ARCHIVE
		</b-button>
		<b-button
			@click="bulkArchiveRestore('restore')"
			type="is-success"
			:disabled="!restoreCheckedList.length"
			v-else>
			RESTORE
		</b-button>
		<b-button
			style="float: right; margin-right: 30px;margin-bottom: 20px;"
			:loading="importLoading"
			@click="importData">
			IMPORT
		</b-button>

		<div class="b-table">
			<div class="table-wrapper has-mobile-cards has-sticky-header" style="width:100%; height:75vh !important;">
				<table class="table">
					<thead>
						<tr>
							<th class="is-sticky-column-one is-sticky is-unselectable">
								<b-checkbox v-model="checkAll"></b-checkbox>
							</th>
							<th class="is-sticky-column-one is-sticky is-unselectable">
								Category
							</th>
							<th class="is-sticky-column-one is-sticky is-unselectable">
								Code
							</th>
							<th class="is-sticky-column-one is-sticky is-unselectable">
								Description
							</th>
							<th class="is-sticky-column-one is-sticky is-unselectable">
								Order
							</th>
							<th class="is-sticky-column-one is-sticky is-unselectable" style="width:100px;">
								&nbsp;
							</th>
						</tr>
					</thead>
					<tbody>
						<tr draggable="false" class="" v-for="(rate, key) in rates">
							<td class="is-sticky-column-one is-sticky">
								<b-checkbox v-model="archiveCheckedList" :native-value="rate.id" v-if="rate.status"></b-checkbox>
		              			<b-checkbox v-model="restoreCheckedList" :native-value="rate.id" v-else></b-checkbox>
			                </td>
							<td class="is-sticky-column-one is-sticky">
			                    {{ rate.category }}
			                </td>
							<td class="is-sticky-column-one is-sticky">
			                    {{ rate.ninaCode }}
			                </td>
							<td class="is-sticky-column-one is-sticky">
								{{ rate.description }}
			                </td>
							<td class="is-sticky-column-one is-sticky">
								{{ rate.displayOrder }}
			                </td>
							<td class="is-sticky-column-one is-sticky">
				              	<span v-if="rate.status">ACTIVE</span>
				              	<span v-else>ARCHIVED</span>
			                </td>
			            </tr>
			        </tbody>
			    </table>
			</div>
		</div>
	</section>
</template>
<script>
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import FlatfileImporter from 'flatfile-csv-importer'
import VueJsonPretty from 'vue-json-pretty'
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import BaseTable from "@/components/partials/BaseTable";
import config from "@/config/index";
export default {
	components: { VueJsonPretty, BaseTable },
	props: ['firm', 'organization'],
	orderOperationClaimServiceService: OrderOperationClaimServiceService,
	columns: [
		{
			field: "Action",
			label:"",
			meta:{
				rowSlot:"rowCheckbox",
				class: 'is-narrow'
			}
		},
		{ field: "ninaCode", label: "Nina Code" },
		{ field: "category", label: "Category" },
		{ field: "displayOrder", label: "Display Order" },
		{
			field: "Action",
			label:"Action",
			meta:{
				rowSlot:"rowAction",
				class: 'is-narrow'
			}
		}
	],
    data: () => ({
    	dataResult: null,
    	modalData: false,
    	importLoading: false,
    	isLoading: false,
    	claims: [],
        loading: false,
        perPage: 1000,
        total: 0,
        currentPage: 1,
        params: {
        	id: 0,
			archived: false,
			order_by: 'display_order',
			sort_by: 'ASC',
        },
        archiveCheckedList: [],
        restoreCheckedList: [],
        importer: null,
        rates: [],
        checkAll: false,
    }),
    computed: {
        user() {
            return this.$store.state.Auth.user;
        },
    },
    watch: {
    	'params.archived'() {
    		this.fetch();
    	},
    	organization() {
    		this.params.id = this.organization.id;
    		this.$nextTick(() => {
    			this.fetch();
    		});
    	},

    	checkAll(value) {
    		if (value) {
    			this.archiveCheckedList = this.rates.map(element => element.id);
				this.restoreCheckedList = this.rates.map(element => element.id);

    		} else {
    			this.archiveCheckedList = [];
				this.restoreCheckedList = [];
    		}
    	}
    },
    methods: {
	    onTableFetch(data) {
	      this.$emit("fetch", data);
	    },
        onPageChange(page) {
            this.currentPage = page;
            this.fetch();
        },
        async importData() {
        	// this.registerValidatorCallback();
			let data = await OrderOperationClaimServiceService.getClaimServices({id: this.organization.id, validation: true});
        	data = data.map(element => element.nina_code);
        	let localRecord = [];
        	this.importer.registerRecordHook((record, index) => {
        		index = index - 1;
        		if(typeof localRecord[index] === 'undefined') {
        			localRecord.push(record);
				}else{
					localRecord[index].nina_code = record.nina_code;
				}
        		let error = {};
				if (data.includes(record.nina_code)) {
					error.nina_code = {
						info: [
							{
								message: "Duplicate: This rate code has been imported previously.",
								level: "error"
							}
						]
					};
				}else{
					let nina_code = localRecord.map(element => element.nina_code);
					let count = nina_code.filter(element => element == record.nina_code).length;
					if (count > 1) {
						error.nina_code = {
							info: [
								{
									message: "Duplicate: Import file contains multiple records of this rate code.",
									level: "error"
								}
							]
						};
					}
				}
				return error;
        	});
        	await this.importer.requestDataFromUser().then(response => {
				// this.importer.displayLoader();
				this.uploadData(response.data);
        	});
        },
        async uploadData(data) {
        	this.modalData = true;
        	await OrderOperationClaimServiceService.uploadData(this.organization.id, data).then(response => {
        		this.dataResult = response;
        		this.importer.close();
		        this.$buefy.toast.open({
					message: "Code successfully imported.",
					type: "is-success",
					position: "is-top-right"
		        });
				// this.importer.displaySuccess('Data Successfully Imported')
            	this.fetch();
        	}).catch(error => {
        		this.modalData = false;
				this.importer.displayError(error.message)
        	});
        },
        async registerValidatorCallback() {
        	let data = await OrderOperationClaimServiceService.getClaimServices({id: this.organization.id, validation: true});
        	this.importer.registerValidatorCallback(function (record) {
				let error = [];
				if (record.nina_code) {
					if (data.filter(element => element.nina_code == record.nina_code).length > 0) {
						error.push({ key: "nina_code", message: "Nina Code Alreasy exist" });
					}
				}
				return error;
			});
        },
	     async fetch(file = null) {
	     	OrderOperationClaimServiceService.getClaimServices(this.params).then(response => {
	     		this.rates = JsonDenormalizer.denormalize(response);
	     	})
	      // await this.$refs.filesTable.fetchData();
	    },
	    async toggleStatus(row) {
	    	OrderOperationClaimServiceService.toggleStatus({id: row.id}).then(response => {
	    		this.fetch();
	    	});
	    },
	    async bulkArchiveRestore(type) {
	    	if (type == 'archive') {
	    		await OrderOperationClaimServiceService.bulkArchive({ids: this.archiveCheckedList});
	    		this.archiveCheckedList = [];
	    	}else{
	    		await OrderOperationClaimServiceService.bulkRestore({ids: this.restoreCheckedList});
	    		this.restoreCheckedList = [];
	    	}
	    	this.fetch();
	    }
    },
    mounted() {
    	this.params.id = this.organization.id;
    	this.fetch();
    	FlatfileImporter.setVersion(2)
		this.importer = new FlatfileImporter(config.flatfileLicense, config.rateFlatfileOptions);
    	this.importer.setCustomer({
		    userId: this.user.id,
		    name: this.user.fullName,
		    email: this.user.email,
		});
    }
};
</script>
<style scoped>
.fa-exclamation-circle{
	font-size: 18px;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationRates.vue